<template>
  <div class="gallery">
    <h1>This is the Gallery</h1>
    <img src="@/assets/tandem-x-visuals-FZOOxR2auVI-unsplash.jpg" alt="" />
  </div>
</template>

<script>
export default {}
</script>

<style lang="scss" scoped>
img {
  width: 100%;
}
</style>
